
// Libraries
import React, { PureComponent } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from '../../routes/routes';
import phrasebookLoad from "../../i18n";
import * as token from '../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../constants';
import { capitalizeFirstLetter, permissionFinder } from "../../helpers/util"



// Redux
import { customerActions, reportActions, georesourceActions } from 'actions';

// Components
import { Table } from "../../components/SkyFramework/Tables/Table";
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton } from "../../components/SkyFramework/Buttons/SubmitButton";
import { SearchBox } from "../../components/SkyFramework/Search";
import { PaginationBar } from "../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Sector } from 'recharts';

const data = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

// Constants
const phrasebook = phrasebookLoad()

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.service_type}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`PV ${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

class SummaryOverview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      category: 'orders',
      name: 'summaryoverview',
      report: undefined,
      customers: undefined,
      countries: undefined,
      customer_id: undefined,
      jurisdiction: undefined

    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onPieEnter = this.onPieEnter.bind(this);

  }

  onPieEnter = (_, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  componentDidMount() {
    if (token.loggedAccountType() < 200) {
      this.props.dispatch(customerActions.getAll(0, this.state.page));
    }
    this.props.dispatch(reportActions.get(this.state.category, this.state.name));
    this.props.dispatch(georesourceActions.getCountries(null, 1000));


  }

  componentDidUpdate(prevProps) {
    if (this.props.customers && prevProps && prevProps.customers !== this.props.customers) {
      this.setState({ customers: this.props.customers.data });
    }
    if (this.props.report && prevProps && prevProps.report !== this.props.report) {
      this.setState({ report: this.props.report });
    }
    if (this.props.countries && prevProps && prevProps.countries !== this.props.countries) {
      this.setState({ countries: this.props.countries.data });
    };
  }


  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    var searchValues = {
      customer_id: this.state.customer_id,
      jurisdiction: this.state.jurisdiction
    };
    this.setState({ filters: searchValues });
    this.props.dispatch(reportActions.get(this.state.category, this.state.name, searchValues));

  }

  SearchBox() {
    var filters = [[]]
    if (this.state.countries) {

      if (token.loggedAccountType() < 200 && this.state.customers) {
        const customerOptions = this.state.customers.map(function (customer) {
          return { value: customer['id'], label: capitalizeFirstLetter(customer['name']) };
        });
        filters[0].push({ label: phrasebook.common.customer, type: "select", id: "customer_id", name: "customer_id", options: customerOptions, empty_option: true })
      }

      const countryOptions = this.state.countries.map(function (country) {
        return { value: country.name, label: country.name };
      });

      filters[0].push({ label: phrasebook.profile.jurisdiction, type: "select", id: "jurisdiction", name: "jurisdiction", options: countryOptions, empty_option: true })


      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)

    } else return null;
  }

  SummaryOverviewTable() {
    if (this.state.report) {//too
      var labels = [
        'ITFS',
        'UIFN',
        'DID',
        'SIP Trunking'
      ];
      // Here we prepare the data for the table;
      let serviceReport = [{
        ITFS: 0,
        UIFN: 0,
        DID: 0,
        'SIP Trunking': 0
      }]

      this.state.report.map(service => {
        Object.keys(serviceReport[0]).map(key => {
          if (key == service.service_type) {
            serviceReport[0][key] = service.count;
          }
        })
      })

      var fields = ['ITFS', 'UIFN', 'DID', 'SIP Trunking']


      return (<>

        <br></br>
        <Table
          values={serviceReport}
          headers={labels}
          keys={fields}
        /></>)
    } else return null;
  }

  render() {
    if (this.state.report) {
      return <>
        <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.reports.order_overview} />
        <div className="box p-1 p-sm-2">
          <h2 className="box-title pb-1 mb-1">{phrasebook.reports.order_overview}</h2>
          {this.SearchBox()}

        </div>
        <div className="box p-1 p-sm-2 my-md-1">
          <h3 className="box-title pb-1 mb-1">{phrasebook.reports.service_count}</h3>
          {this.SummaryOverviewTable()}
        </div>
        <div class="row">
          <div class="col-xs-6">
            <div className="box p-1 p-sm-2">
              <h4 className="box-title pb-1 mb-1">Order Service Bar Chart</h4>
              {this.state.report ?
                <BarChart width={250} height={250} data={this.state.report}>
                  <XAxis dataKey="service_type" />
                  <Bar dataKey="count" fill="#8884d8" />
                </BarChart>
                : null}
            </div>
          </div>
          <div class="col-xs-6">
            <div className="box p-1 p-sm-2">
              <h4 className="box-title pb-1 mb-1">Order Service Pie Chart</h4>
              {this.state.report ?
                <PieChart width={500} height={250}>
                  <Pie
                    activeIndex={this.state.activeIndex}
                    activeShape={renderActiveShape}
                    data={this.state.report}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="count"
                    onMouseEnter={this.onPieEnter}
                  />
                </PieChart>
                : null}
            </div>
          </div>
        </div>
      </>
    } else return null;

  }
}

function mapStateToProps(state) {
  const { authentication, loggedpermissions, report, georesource, customer } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    customers: customer.customers,
    report: report.report,
    countries: georesource.countries
  };
}

const summary = connect(mapStateToProps)(SummaryOverview);

//export default withStyles(styles)(partnersite);
export default (summary);
